import { useEffect, useState } from "react";
import { Camera } from "lucide-react";
import { PhotoDialog, PhotoHeart } from "@/components/ProfilePhotos";
import { api } from "@/lib/api";
import { imgSrc } from "@/lib/categories";

export function TopPhotos({ city }) {
  const [photos, setPhotos] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    let live = true;
    setPhotos([]);
    api.get("/photos/top", { params: { city } }).then((r) => live && setPhotos(r.data)).catch(() => {});
    return () => { live = false; };
  }, [city]);
  const onLiked = (url, data) => {
    setPhotos((xs) => xs.map((x) => (x.url === url ? { ...x, ...data } : x)));
    setOpen((o) => (o && o.url === url ? { ...o, ...data } : o));
  };
  if (photos.length < 3) return null;

  return (
    <section data-testid="top-photos" className="mb-8">
      <h3 className="text-lg font-bold flex items-center gap-2 mb-3"><Camera className="h-4 w-4 text-[#FF3B6B]" /> Most-loved photos in {city}</h3>
      <div className="-mx-4 px-4 flex gap-3 overflow-x-auto no-scrollbar pb-2">
        {photos.map((ph, i) => (
          <button key={ph.url} type="button" data-testid={`top-photo-${i}`} onClick={() => setOpen(ph)}
            className="rise group relative shrink-0 h-44 w-36 sm:h-52 sm:w-44 rounded-2xl overflow-hidden border border-[#26334D] text-left" style={{ animationDelay: `${i * 50}ms` }}>
            <img src={imgSrc(ph.url)} alt={ph.caption || ph.place_name || "Traveler photo"} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
            <span className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-[#0B0F19] via-[#0B0F19]/70 to-transparent p-2 text-xs">
              <span className="block font-semibold truncate">{ph.caption || ph.place_name}</span>
              <span className="flex items-center justify-between gap-2 text-slate-300">
                <span className="truncate">{ph.author.name}</span>
                <PhotoHeart photo={ph} canLike={ph.follows_author && !ph.is_mine} onLiked={onLiked} tid={`top-photo-like-${i}`} />
              </span>
            </span>
          </button>
        ))}
      </div>
      <PhotoDialog photo={open} author={open?.author} canComment={open?.follows_author} canLike={open?.follows_author && !open?.is_mine}
        showComments={!!open?.follows_author} isMe={false} onLiked={onLiked} onClose={() => setOpen(null)} onDeleted={() => setOpen(null)} />
    </section>
  );
}
